export const PREVIEW_FEATURES = [
  {
    id: "salesforce_source",
    name: "SalesForce",
    group: "dss",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "it_scripts",
    name: "Playbooks",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "reports",
    name: "Reports",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },

  {
    id: "csv_report_scheduler",
    name: "CSV report schedule",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },

  {
    id: "pdf_report_schedule",
    name: "PDF report schedule",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "executive_reports",
    name: "Executive reports",
    group: "generic",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "pdf_report",
    name: "PDF report generation",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },

  {
    id: "risky_events_report",
    name: "Risky Events Report",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "conversation",
    name: "Conversation",
    group: "generic",
    controllable: true,
    enabled: false,
    exposable: true,
  },
  {
    id: "data_scanner_service",
    name: "Data Source Service",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },

  {
    id: "security_posture",
    name: "Security Posture",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "overview",
    name: "Overview",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  /*  {
    id: "365_scanner",
    name: "365 scanner",
    group: "info_at_rest",
    controllable: true,
    enabled: true,
    exposable: true,
  }, */
  {
    id: "on_premises",
    name: "on-premises",
    group: "info_at_rest",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "sp_site_permission",
    name: "Sharepoint site permission",
    group: "info_at_rest",
    controllable: false,
    enabled: true,
    exposable: true,
  },

  {
    id: "auto_mip_labeling",
    name: "auto mip labeling",
    group: "generic",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "manual_mip_labeling",
    name: "Manual MIP labeling",
    group: "generic",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "expose_other",
    name: "Expose other classification",
    group: "generic",
    controllable: false,
    enabled: false,
    exposable: true,
  },
  {
    id: "unprotected_accounts",
    name: "Unprotected Accounts",
    group: "identities_protection",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "custom_information_type",
    name: "Custom Information type",
    group: "information_visibility",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "folders_context_labels",
    name: "Folders context labels",
    group: "information_visibility",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "pii_labeler",
    name: "PII labeler",
    group: "information_visibility",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "azure_storage",
    name: "Azure storage",
    group: "info_at_rest",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "aws_storage",
    name: "AWS storage",
    group: "info_at_rest",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "endpoints_scanner",
    name: "Endpoints Scanner",
    group: "info_at_rest",
    controllable: false,
    enabled: true,
    exposable: true,
  },
  {
    id: "gmail_connector",
    name: "Gmail connector",
    group: "additional_connectors",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "departments_information",
    name: "Departments' information",
    group: "generic",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "recommendations",
    name: "Recommendations",
    group: "info_protection_deployment",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "justification_automation",
    name: "Justification automation",
    group: "autonomous_compliance",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "mark_as_handled",
    name: "Mark as handled",
    group: "autonomous_compliance",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "download_policy",
    name: "Download Policy",
    group: "autonomous_compliance",
    controllable: true,
    enabled: true,
    exposable: true,
  },
  {
    id: "educate_risky_users",
    name: "Educate risky users",
    group: "autonomous_compliance",
    controllable: true,
    enabled: true,
    exposable: true,
  },
];
